const SET_USER_INFORMATION = 'USER/SET_USER_INFORMATION';
const LOAD_USER = 'USER/LOAD_USER';
const UPDATE_USER = 'USER/UPDATE_USER';
const RESET_PASSWORD = 'USER/RESET_PASSWORD';
const LOAD_USER_INFORMATION = 'USER/LOAD_USER_INFORMATION';

export { LOAD_USER_INFORMATION, LOAD_USER, SET_USER_INFORMATION, UPDATE_USER, RESET_PASSWORD };
